import { render, staticRenderFns } from "./sopAdditionalInfo.vue?vue&type=template&id=aa6516fe"
import script from "./sopAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./sopAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./sopAdditionalInfo.vue?vue&type=style&index=0&id=aa6516fe&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6516fe')) {
      api.createRecord('aa6516fe', component.options)
    } else {
      api.reload('aa6516fe', component.options)
    }
    module.hot.accept("./sopAdditionalInfo.vue?vue&type=template&id=aa6516fe", function () {
      api.rerender('aa6516fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopAdditionalInfo.vue"
export default component.exports